import AppRoutes from './util/Routes';
import './App.css';

function App() {
  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;
